import type { RootState } from 'core/store';
import { put } from 'core/middlewares/utilities';
import { checkout, utilities } from 'core/use-cases';

import { getters } from './getters';
import { confirmation } from './confirmation';
import { notification } from './tasks';
import { PAYMENT_PLAN_TYPE } from 'core/services/bff';
import { CHECKOUT_VIEW } from 'core/domains';
import { getLocationPathname } from 'core/utilities';

/**
 * Orchestrate the retry order
 *
 */
export function* retryOrder() {
  const { isRetry }: RootState['checkout'] = yield getters.getCheckout();
  const pathname = getLocationPathname();

  const conditional = ['40', '50', 'confirmation', 'process'];
  const hasRoute = conditional.some((elemento) => pathname.includes(elemento));

  /* istanbul ignore else */
  if (pathname !== '/checkout' && !isRetry) {
    return;
  }

  const {
    data: { status: statusDetail },
  }: RootState['order'] = yield getters.getOrder();

  /* istanbul ignore else */
  if (!statusDetail) {
    return;
  }

  const { paymentPlanType }: getters.PaymentOption = yield getters.getPaymentOption();

  const isErrorCreditCard = paymentPlanType === PAYMENT_PLAN_TYPE.CREDIT_CARD;

  /* istanbul ignore else */
  if (isRetry && !hasRoute) {
    yield notification.error({
      type: checkout.actions.paymentDetailFetch.failure.type,
      meta: {},
    } as utilities.ActionFailure);
  }

  /* istanbul ignore else */
  if (isErrorCreditCard) {
    if (statusDetail === 'paymentProcess') {
      yield confirmation();

      return;
    }

    yield put(checkout.actions.setStep('payment'));
    yield put(checkout.actions.setView(CHECKOUT_VIEW.PAYMENT_ERRORS));

    return;
  }

  /* istanbul ignore else */
  if (statusDetail === 'capture') {
    yield put(checkout.actions.setStep('summary'));

    return;
  }

  yield confirmation();
}
